import {
  useModalContext,
  WSContainer,
  WSFlexBox,
  WSForm,
  WSLayout,
  WSModal,
  WSRadioInputGroup,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useEffect } from "react";
import * as Yup from "yup";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import styles from "./styles.module.scss";
import { useBeginOTPSession } from "../../query/users/mutations";
import { useUserId } from "../../query/hooks/helpers";
import { ErrorContextKey } from "../../services/platform";
import {
  EmailVerificationStatus,
  IOtpSessionCreateRequest,
  OtpVerificationChannel,
  PhoneVerificationStatus
} from "@wingspanhq/users/dist/lib/interfaces";
import { useUserProfile } from "../../query/users/queries";
import { WSQueries } from "../../query/WSQuery";
import { useState } from "react";
import mainStyles from "./Select2FAChannelForm.module.scss";
import {
  SESSION_OTP_MODAL,
  useOpenSessionOTPModal
} from "../../components/SessionOTPModal/SessionOTPModal";
import { censorEmail, censorPhone } from "../../utils/stringHelper";
export interface Select2FAChannelFormProps {}

export const SELECT_2FA_CHANNEL_FORM_MODAL = "SELECT_2FA_CHANNEL_FORM_MODAL";

export const Select2FAChannelFormModal: React.FC<Select2FAChannelFormProps> = () => {
  const history = useHistory();
  const location = useLocation();
  const { closeModal, openModal } = useModalContext();
  const userId = useUserId();
  const userProfileQuery = useUserProfile(userId);
  const [channel, setChannel] = useState<OtpVerificationChannel | null>(
    userProfileQuery.data?.phone.status === PhoneVerificationStatus.Verified
      ? OtpVerificationChannel.SMS
      : userProfileQuery.data?.emailVerificationState?.status ===
        EmailVerificationStatus.Verified
      ? OtpVerificationChannel.Email
      : null
  );
  const [beginOTPSession, beginOTPSessionMeta] = useBeginOTPSession();
  const [openSessionOTPModal] = useOpenSessionOTPModal();

  const queries = queryString.parse(location.search);

  useEffect(() => {
    const nextUrl = queries.next as string;
    if (nextUrl) {
      window.sessionStorage.setItem("OTP_FLOW_NEXT_URL", nextUrl);
    }
  }, []);

  const onFormSubmit = async (data: any, modalProps: any) => {
    const request: IOtpSessionCreateRequest = {
      channel: data.channel,
      appRedirectPath:
        modalProps.callbackUrl || `${location.pathname}${location.search}`
    };
    await beginOTPSession(request, {
      onSuccess: () => {
        if (data.channel === OtpVerificationChannel.Email) {
          closeModal(SELECT_2FA_CHANNEL_FORM_MODAL);
          history.push("/member/authorize/2fa/email");
        } else if (data.channel === OtpVerificationChannel.SMS) {
          openModal(SESSION_OTP_MODAL, modalProps);
        }
      }
    });
  };

  return (
    <WSModal
      name={SELECT_2FA_CHANNEL_FORM_MODAL}
      size="M"
      fullScreen
      fullScreenOnMobile
      className={mainStyles.modalBody}
    >
      {props => (
        <WSQueries queries={{ userProfileQuery }}>
          {({ userProfileQuery: { data: user } }) => {
            const channelOptions = [];
            if (
              user.emailVerificationState?.status ===
              EmailVerificationStatus.Verified
            ) {
              channelOptions.push({
                value: OtpVerificationChannel.Email,
                label: `Email (${censorEmail(user.email)})`
              });
            }

            if (user.phone.status === PhoneVerificationStatus.Verified) {
              channelOptions.push({
                value: OtpVerificationChannel.SMS,
                label: `Phone (${censorPhone(user.phone.number as string)})`
              });
            }
            return (
              <WSFlexBox
                alignContent="center"
                alignItems="stretch"
                direction="column"
                p="M"
              >
                <WSText.Heading3 mb="S" align="center">
                  Security confirmation
                </WSText.Heading3>
                <WSText.Paragraph color="grey700" mb="M" align="left">
                  A 6 digit verification code will be sent via
                  <br />
                  SMS to your mobile device (Message and
                  <br />
                  Data rates may apply) or a verification link
                  <br />
                  will be sent to your email address.
                </WSText.Paragraph>
                <WSForm
                  onSubmit={data => onFormSubmit(data, props)}
                  defaultValues={{
                    channel:
                      user.phone.status === PhoneVerificationStatus.Verified
                        ? OtpVerificationChannel.SMS
                        : OtpVerificationChannel.Email
                  }}
                  validationSchema={Yup.object().shape({
                    channel: Yup.string().required("Select 2FA channel")
                  })}
                  className={mainStyles.form}
                >
                  <WSForm.Field
                    name="channel"
                    component={WSRadioInputGroup}
                    componentProps={{
                      options: channelOptions,
                      onChange: e => setChannel(e.target.value)
                    }}
                    label="Select"
                  />

                  <WSErrorMessage
                    mt="S"
                    error={beginOTPSessionMeta.error}
                    contextKey={ErrorContextKey.VerifyPhone}
                  />
                  <WSForm.SubmitButton
                    name="selectTwoFactorAuthChannel"
                    mt="XL"
                    fullWidth
                    className={styles.button}
                    loading={beginOTPSessionMeta.isLoading}
                  >
                    Continue
                  </WSForm.SubmitButton>
                </WSForm>
              </WSFlexBox>
            );
          }}
        </WSQueries>
      )}
    </WSModal>
  );
};
